import { FC, ReactNode } from 'react';

import { MultiStepFormProvider, useMultiStepForm } from '../context';

import '../multi-step-form.css';

export interface IFormStep {
  title: string;
  content: ReactNode;
}

interface IProps {
  steps: IFormStep[];
  showIndicators?: boolean;
  visibleIndicatorSteps?: number[];
}

const MultiStepFormContent: FC<IProps> = ({
  steps,
  showIndicators = true,
  visibleIndicatorSteps,
}) => {
  const { currentStep, totalSteps } = useMultiStepForm();

  const indicatorSteps = visibleIndicatorSteps
    ? steps.filter((_, i) => visibleIndicatorSteps.includes(i))
    : steps;

  const getIndicatorState = (step: IFormStep) => {
    const realIndex = steps.indexOf(step);
    if (realIndex === currentStep) return 'is-active';
    if (realIndex < currentStep) return 'is-completed';
    return '';
  };

  return (
    <div className='multi-step-form'>
      {showIndicators && totalSteps > 1 && (
        <div className='multi-step-form__indicators'>
          {indicatorSteps.map((step, displayIndex) => (
            <div
              key={step.title}
              className={`multi-step-form__indicator ${getIndicatorState(step)}`}
            >
              <span className='multi-step-form__indicator-number'>{displayIndex + 1}</span>
              <span className='multi-step-form__indicator-title'>{step.title}</span>
            </div>
          ))}
        </div>
      )}

      <div className='multi-step-form__content'>{steps[currentStep]?.content}</div>
    </div>
  );
};

export const MultiStepForm: FC<IProps> = props => {
  return (
    <MultiStepFormProvider totalSteps={props.steps.length}>
      <MultiStepFormContent {...props} />
    </MultiStepFormProvider>
  );
};
